module.exports = __webpack_public_path__ + "img/xxzx.0c41da25.png";